import { queryClient } from 'data/hooks/_helpers'
import { includeFieldsToRelatedFieldSuffix } from 'data/hooks/recordQueryKeySuffix'
/**
 * Gets the record from the query cache
 * @param {string} recordId
 */

export const getCachedRecord = (
    recordId: string,
    requiredFields?: string[]
): RecordDto | undefined => {
    const suffix = includeFieldsToRelatedFieldSuffix(requiredFields)
    if (!!suffix) {
        return queryClient.getQueryData(['record', recordId, suffix])
    }

    // Just get the first cache entry for the record.
    const result = queryClient.getQueryCache().findAll({
        predicate: (query) => {
            const queryKey = query.queryKey
            // Check if queryKey is an array and starts with the prefix
            return Array.isArray(queryKey) && queryKey[0] === 'record' && queryKey[1] === recordId
        },
    })

    if (result.length > 0) {
        return result[0].state.data as RecordDto | undefined
    }
}
